<template>
    <div @click="onFilterClose()" class="messages-filter">
        <form @click.stop>
            <div class="content">
                <fieldset class="control-group max-size" v-if="route.query.qs !== 'quicksearch' && route.query.qs !== 'fullsearch'">
                    <legend>{{Language.say('messages.filter.filter_by')}}</legend>

                    <ul class="control radio-buttons-group">
                        <li>
                            <input type="radio" name="filterBy" id="filter_attach" :checked="route.query.qsearchfilter === 'filter_attach'" tabindex="-1">
                            <label @click="onSetFilter('filter_attach')" for="attach" tabindex="0">{{Language.say('messages.filter.with_attach')}}</label>
                        </li>
                        <li>
                            <input type="radio" name="filterBy" id="flagged" :checked="route.query.qsearchflag === '\\flagged'" tabindex="-1">
                            <label @click="onSetFlag('\\flagged', 0)" for="flagged" tabindex="0">{{Language.say('messages.filter.flagged')}}</label>
                        </li>
                        <li>
                            <input type="radio" name="filterBy" id="unread" :checked="route.query.qsearchflag === '\\seen'" tabindex="-1">
                            <label @click="onSetFlag('\\seen',1)" for="unread" tabindex="0">{{Language.say('messages.filter.unread')}}</label>
                        </li>
                    </ul>
                </fieldset>

                <fieldset>
                    <legend>{{Language.say('messages.filter.order_by')}}</legend>

                    <div class="control-group max-size">
                        <ul class="control radio-buttons-group">
                            <li><span>{{Language.say('messages.filter.date')}}</span></li>
                            <li>
                                <input type="radio" name="orderType" id="new" :checked="messages.sort_by === 1 && messages.sort_direction === 1" tabindex="-1">
                                <label @click="onSetOrder(1,1)" for="new" tabindex="0">{{Language.say('messages.filter.new')}}</label>
                            </li>
                            <li>
                                <input type="radio" name="orderType" id="old" :checked="messages.sort_by === 1 && messages.sort_direction === 0" tabindex="-1">
                                <label @click="onSetOrder(1,0)" for="old" tabindex="0">{{Language.say('messages.filter.old')}}</label>
                            </li>
                        </ul>
                    </div>

                    <div class="control-group max-size">
                        <ul class="control radio-buttons-group">
                            <li><span>{{Language.say('messages.filter.subject')}}</span></li>
                            <li>
                                <input type="radio" name="orderType" id="subjectAz" :checked="messages.sort_by === 7 && messages.sort_direction === 0" tabindex="-1">
                                <label @click="onSetOrder(7,0)" for="subjectAz" tabindex="0">A-Z</label>
                            </li>
                            <li>
                                <input type="radio" name="orderType" id="subjectZa" :checked="messages.sort_by === 7 && messages.sort_direction === 1" tabindex="-1">
                                <label @click="onSetOrder(7,1)" for="subjectZa" tabindex="0">Z-A</label>
                            </li>
                        </ul>
                    </div>

                    <div class="control-group max-size">
                        <ul class="control radio-buttons-group">
                            <li><span>{{Language.say('messages.filter.sender')}}</span></li>
                            <li>
                                <input type="radio" name="orderType" id="senderAz" :checked="messages.sort_by === 4 && messages.sort_direction === 0" tabindex="-1">
                                <label @click="onSetOrder(4,0)" for="senderAz" tabindex="0">A-Z</label>
                            </li>
                            <li>
                                <input type="radio" name="orderType" id="senderZa" :checked="messages.sort_by === 4 && messages.sort_direction === 1" tabindex="-1">
                                <label @click="onSetOrder(4,1)" for="senderZa" tabindex="0">Z-A</label>
                            </li>
                        </ul>
                    </div>
                </fieldset>
            </div>

        </form>

    </div>
</template>

<script setup>
  import {defineProps, defineEmits}   from "vue";
  import {onBeforeMount, onUnmounted} from 'vue';
  import {useRoute}                   from "vue-router";
  import KeyboardController           from '@/js/Webmail/Keyboard/KeyboardController';
  import Language                     from '@/js/Shared/Language/Language.js';
  import SAPOMailConfig               from "@/SAPOMailConfig";

  const emit = defineEmits([
    'messagesFilterClose',
  ]);

  const props = defineProps({
    folder_id           : {},
    messages            : {},
    messages_view       : {},
    webmail_view        : {},
    viewport_controller : {},
  });

  const route = useRoute();

  onBeforeMount(() => {
    KeyboardController.disableAll();
  })

  onUnmounted(() => {
    KeyboardController.enableAll();
  })

  const onFilterClose = () => {
    close();
  }

  const onSetOrder = (sort_by, sort_direction) => {
    if (props.messages.sort_by === sort_by && props.messages.sort_direction === sort_direction) {
      return;
    }

    props.viewport_controller.fetchMessagesSort(props.folder_id, sort_by, sort_direction);
    close();
  }

  const onSetFlag = (flag, not) => {
    if (route.query.qsearchflag === flag) {
      return;
    }

    let query = {
      qsearchflag    : flag,
      qsearchflagnot : not,
    }

    goToSearch(query);
  }

  const onSetFilter = (filter) => {
    if (route.query.qsearchfilter === filter) {
      return;
    }

    let query = {
      qsearchfilter: filter,
    }

    goToSearch(query);
  }

  const goToSearch = (query) => {
    query.qs           = 'filter',
    query.qsearchfield = 'all';
    query.qsearchmbox  = route.query.qsearchmbox ? route.query.qsearchmbox : props.folder_id;

    props.webmail_view.routeTo('/messages/' + SAPOMailConfig.client.folders.alias.search, query);
  }

  const close = () => {
    emit('messagesFilterClose');
  }
</script>
